<template>
  <div style="width:100%;height:100%;position:absolute;top:0;bottom:0;left:0;right:0">
    <div class="desc-bg"></div>
    <!--<div class="bg-opacity"></div>-->
    <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
      <div class="login-div">

        <div class="box-login">
          <div class="flex justify-center login-header">
            <img :src="logo" style="height:32px;margin-top:16px;">
          </div>
          <div class="login-content-div">
            <div style="padding: 40px;text-align:center">
              <!--<div class="lp-login-logo" style="margin:0 auto"></div>
              <div class="flex justify-center" style="font-size:1.2rem;margin-top:4px">LAUNCH PACK</div>-->
              <div style="font-weight:bold;font-size:1.2rem">슈퍼바이저 로그인</div>
            </div>
            <div style="padding:0 42px 68px 42px;">
              <div>
                <input :style="errorStyle" @focus="isError=false"
                       type="text" placeholder="아이디" v-model="item.username"
                       name="아이디"/>
              </div>
              <span v-show="errors.has('아이디')" class="help is-danger">{{ errors.first('아이디') }}</span>
              <div style="margin-top:8px">
                <input :style="errorStyle" @focus="isError=false" id="input-password" type="password" placeholder="비밀번호" @keyup.enter="login" v-model="item.password"
                       name="비밀번호" v-validate="'required'"/>
              </div>
              <span v-show="errors.has('비밀번호')" class="help is-danger">{{ errors.first('비밀번호') }}</span>
              <span v-if="item.wrong_msg && item.password" class="help is-danger">{{ item.wrong_msg }}</span>
              <button id="btn-login" class="btn" :style="loginButtonStyle" @click="login">로그인</button>
            </div>
          </div>
        </div>

        <div class="flex" v-if="false">
          <div class="flex" style="margin-left: auto;">
            <div class="flex">
              <div class="btn">아이디 찾기</div>
            </div>
            <div class="flex" style="margin-left: 10px;">
              <div class="btn">비밀번호 찾기</div>
            </div>
          </div>
        </div>

        <div style="margin-top:16px">
          <div class="login-desc">아이디와 비밀번호를 입력하시면 슈퍼파트너로 로그인 하실 수 있습니다.</div>
          <div class="login-desc">런치팩을 방문하시려면 <a href="https://launchpack.co.kr" target="_blank">런치팩 바로가기</a>를 클릭해주세요</div>
        </div>

        <!--<div class="copyright">Copyright @ Launchpack. All rights reserved.</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SuperVisorLogin',
    data() {
      return {
        item: {
          username: '',
          password: '',
          wrong_msg: ''
        },
        isError: false,
        logo: ''
      }
    },
    created() {
      this.$axios.get('public/service/info').then(res=>{
        if(res.data.business_info.img!=='')
          this.logo = res.data.business_info.img;
      });
    },
    computed: {
      errorStyle(){
        if(this.isError){
          return 'border: 1px solid red';
        }
      },
      loginButtonStyle(){
        if(this.item.username && this.item.password){
          return 'color: white; background-color: #ff6e49'
        }
        else return '';
      }
    },
    methods: {
      login() {
        this.$validator.validateAll().then(function (res) {
          if (res === false) return;
          var params = {
            username: this.item.username,
            password: this.item.password
          };
          this.$axios.post('/auth/supervisor/login', params)
            .then(function (res) {
              if (res.status === 200) {
                this.$store.commit('setServiceName', res.data.user.service);
                this.$store.commit('setSuperVisor', res.data.user);
                this.setAuthHeader()

                if (this.$store.getters.supervisor.token !== '')
                  this.$store.commit('setMode', 'supervisor');
                this.$router.replace('/office/supervisor/dashboard')
              }
            }.bind(this))
            .catch(error => {
              if (error.response.status > 400) {
                if (error.response.data.detail) {
                  this.item.wrong_msg = error.response.data.detail;
                  this.isError = true;
                }
                else {
                  this.item.wrong_msg = error.response.data.message;
                  this.isError = true;
                }
              }
            });
        }.bind(this)).catch(() => {
        });
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  .lp-login-logo
    width 30px
    height 30px
    background-image url('~assets/image/platformfy_logo.png')

  .desc-bg
    width 100%
    height 100%
    background-color #f5f5f5
    position fixed

  .bg-opacity
    background-color rgba(247, 247, 247,0.25)
    width 100%
    height 100%
    position fixed

  .copyright
    margin-top 60px
    color #A8A9AC
    text-align center
    font-size 12px
    font-weight 300

  .btn
    padding 10px 15px
    text-align center
    background-color #e5e5e5
    color #989898
    font-weight bold
    border-radius 3px
    font-size 14px
    margin-top 20px
    min-width: 80px
    cursor pointer

  input[type="text"], input[type="password"], textarea
    padding 10px
    font-size 14px
    border-radius 3px
    border 1px solid #e6e6e6
    width 100%
    max-width 500px
    background-color #fff

  .help.is-danger
    color #ff3860
    font-size 13px
    margin-top 5px
    display block
    text-align left

  .login-div
    /*margin 110px auto 0 auto*/
    width 362px
    position relative

  .login-header
    width 360px
    height 48px
    border-top-left-radius 3px
    border-top-right-radius 3px
    background-color white

  .login-content-div
    background-color white
    border-bottom-left-radius 3px
    border-bottom-right-radius 3px

  .login-desc
    font-size 12px
    margin-top 4px

  a
    text-decoration underline
    color #000
  a:hover
    color #ff5722

  .box-login
    box-shadow 0 1px 6px 1px rgba(0,0,0,0.12)

  button
    width 100%
    border 0

  input:focus
    border 1px solid #ff5722
    outline 0
</style>
